import React, { useState } from 'react';
import { Button, Col, Input, Label, Row } from "reactstrap";
import CustomModal from '../../../../../../Components/Modals/CustomModal';
import {DropdownList} from "react-widgets";
import HelpTooltip from '../../../../../../Components/Tooltips/HelpTooltip';
import { UpdateAllAsinSkusTaskService } from '../../../../../../../Service/OPSServices/UpdateAllAsinSkusTaskService';

function QuickLaunchCampaignModal(props) {

    const {
        isCampaignOpen,
        setIsCampaignOpen,
        newCampaignDetails,
        setNewCampaignDetails,
        handleQuickLaunchCampaign,
        token,integerId } = props;
        const [loadWindow,setLoadWindow]=useState(false)
console.log(newCampaignDetails)
    const onLaunch = async () => {
        setIsCampaignOpen(!isCampaignOpen);
        let response = await handleQuickLaunchCampaign(newCampaignDetails.productASIN, newCampaignDetails.productSKU, newCampaignDetails.dailyBudget);
        if (response.isFirstCampaign) {

        } else if (response) {
            setIsCampaignOpen(!isCampaignOpen);
        }
        window.location.reload();
    }
    const updateSKUs=async()=>{
        let data = {id : props.integerId, asin: newCampaignDetails.productASIN}
        let response = await UpdateAllAsinSkusTaskService(props.token,data);  
        if(response)
        {
            console.log(response);
            setNewCampaignDetails(prevState => ({
                ...prevState,
                skuList: response,
            }));
            setLoadWindow(true)
        }
    }
    return (
        <CustomModal
            header="1-Click Campaign"
            isOpen={isCampaignOpen}
            toggle={() => {setIsCampaignOpen(!isCampaignOpen); if (loadWindow) window.location.reload();}}
            className='curve-popup'
            footer={
                <Button
                    style={{ backgroundColor: '#533FD1', color: '#fff' }} 
                    onClick={() => onLaunch()}
                    disabled={newCampaignDetails.productSKU === '' || newCampaignDetails.dailyBudget === 0}
                >
                    Launch Campaign
                </Button>
            }
        >
            <Row>
                <Col className="mb-3" md="12">
                    <h6>Simpliworks will manage and optimize bids for this product's 1-Click campaigns to maximize ROAS (Return On Ad Spend).</h6>
                </Col>
                <Col className="mb-3" md="12">
                    <Label>Select Product SKU <span><a onClick={()=>updateSKUs()} href='#'>&#40;<u>Update Skus</u>&#41;</a></span></Label>
                    {/* <DropdownList
                        data={newCampaignDetails.skuList ? newCampaignDetails.skuList : []}
                        value={newCampaignDetails.skuList.join(', ')}  // Convert array to comma-separated string
                        textField="value"
                        onChange={value => setNewCampaignDetails(prevState => ({
                            ...prevState,
                            productSKU: value,
                        }))}
                        placeholder="Product SKU"
                    /> */}
                  <select
                  className='form-control'
                    value={newCampaignDetails.productSKU} 
                    onChange={e => {
                        const selectedValue = e.target ? e.target.value : ''; 
                        setNewCampaignDetails(prevState => ({
                        ...prevState,
                        productSKU: selectedValue, 
                        }));
                    }}
                    placeholder="Select Product SKU"
                    >
                    <option disabled>Select Product SKU</option> 
                    {newCampaignDetails.skuList && newCampaignDetails.skuList.map((sku, index) => (
                        <option key={index} value={sku}>{sku}</option> 
                    ))}
                 </select>

                </Col>
                <Col md="12">
                    <Label for="dailyBudget">Total Daily Budget ($)</Label>
                    <HelpTooltip
                        className={"ml-1"}
                        target="dailyBudget"
                        placement={"auto"}
                        style={{display: "inline"}}
                    >
                        <p>
                            The total budget that will be automatically allocated across all Simpliworks managed campaigns for this product.
                        </p>
                    </HelpTooltip>
                    <Input
                        id="dailyBudget"
                        placeholder="Enter the new campaign's daily budget"
                        value={newCampaignDetails.dailyBudget}
                        onChange={(e) => {
                            let value = e.target.value;
                            setNewCampaignDetails(prevState => ({
                                ...prevState,
                                dailyBudget: value,
                            }))
                        }}
                    />
                </Col>
            </Row>
        </CustomModal>
    )
}

export default QuickLaunchCampaignModal;